import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

export default function ConfirmPasswordForm({ control, errors, dynamicField, label, password }) {

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <>
      <Controller
        name={dynamicField}
        control={control}
        rules={{
          required: `${label} is required`,
          validate: (value) => {
            if (value !== password) {
              return 'Passwords do not match';
            }
            return true;
          },
        }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label={label}
            type={showPassword ? 'text' : 'password'}
            size='small'
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    sx={{ p: 0 }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            helperText={errors[dynamicField] && errors[dynamicField].message}
            error={Boolean(errors[dynamicField])}
          />
        )}
      />
    </>
  )
}
